import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CreateKixieIntegration as CreateKixieIntegrationMutation,
    CreateKixieIntegrationVariables,
    KixieIntegrationCreateInput,
} from 'nutshell-graphql-types';

import CREATE_KIXIE_INTEGRATION from '../mutations/create-kixie-integration.graphql';

export const useCreateKixieIntegration = (): {
    createKixieIntegration: (arg1: KixieIntegrationCreateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [createKixieIntegration, {loading, error}] = useMutation<
        CreateKixieIntegrationMutation,
        CreateKixieIntegrationVariables
    >(CREATE_KIXIE_INTEGRATION);

    return {
        createKixieIntegration: (input: KixieIntegrationCreateInput) =>
            createKixieIntegration({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
